import { Helmet } from 'react-helmet-async'

interface StructuredDataProps {
  isGameWon?: boolean
  isGameLost?: boolean
  guessCount?: number
}

export const StructuredData: React.FC<StructuredDataProps> = ({
  isGameWon = false,
  isGameLost = false,
  guessCount = 0,
}) => {
  const gameSchema = {
    '@context': 'https://schema.org',
    '@type': ['Game', 'WebApplication'],
    name: '言葉で遊ぼう - 無料日本語Wordleゲーム',
    alternateName: [
      'ことばであそぼう',
      'Kotobade Asobou',
      '日本語Wordle 4文字',
      '4文字日本語Wordle',
    ],
    description:
      '言葉で遊ぼう（ことばであそぼう）は、ひらがな4文字の単語を12回以内に当てる無料日本語Wordleゲームです。今日の問題、ヒントモード、過去問カレンダーで語彙と推理を練習できます。',
    url: process.env.REACT_APP_GAME_LINK,
    image: `${process.env.PUBLIC_URL}/kotobade-asobou_card_600x314.png`,
    applicationCategory: 'Game',
    operatingSystem: 'Web',
    gamePlayMode: 'SinglePlayer',
    inLanguage: 'ja',
    author: {
      '@type': 'Person',
      name: 'taximanli',
    },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: process.env.REACT_APP_GAME_LINK,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '言葉で遊ぼう',
        item: process.env.REACT_APP_GAME_LINK,
      },
    ],
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '言葉で遊ぼうは4文字の日本語Wordleですか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。言葉で遊ぼう（ことばであそぼう）は、ひらがな4文字の単語を12回以内に当てる無料の日本語Wordleゲームです。',
        },
      },
      {
        '@type': 'Question',
        name: 'このゲームはどうやって遊びますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日の単語を12回以内に当ててください。それぞれの答えはひらがな4文字の単語である必要があります。入力ボタンを押して答えを決定してください。答えるたびに正方形の色が変わり、それが次のヒントになります。',
        },
      },
      {
        '@type': 'Question',
        name: '毎日新しい単語が出ますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。保存したタイムゾーンの日付に合わせて新しい4文字の問題へ切り替わります。設定画面で自分の地域に合わせて変更できます。',
        },
      },
      {
        '@type': 'Question',
        name: 'どんな単語が含まれていますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '単語リストは、名詞、代名詞、形容詞、副詞及び動詞が含まれています。外来語も含まれています。活用語は、基本的に終止形です。',
        },
      },
      {
        '@type': 'Question',
        name: '5文字の日本語Wordleやことのはたんごの練習にも使えますか？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'はい。4文字盤面は短いので、緑、黄色、灰色の読み方や候補の絞り方を練習しやすく、5文字の日本語Wordleに挑戦する前の準備にも使えます。',
        },
      },
    ],
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(gameSchema)}</script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
  )
}
